import { ChakraBox, ChakraFlex, Text } from '@equip.health/ui';

import { WarningTypes } from '~/lib/constants/patients.constants';

const TOP_LEVEL_ID = 'warning-content';

const AGE_LIMIT = 18;
const SCALE_WEIGHT_LIMIT = 400;

const WarningContent = ({ warning }: { warning?: WarningTypes }) => {
  switch (warning) {
    case WarningTypes.UNDER_18:
      return (
        <ChakraBox
          display="flex"
          flexDirection="column"
          gap="12px"
          id={`${TOP_LEVEL_ID}__under-18`}
        >
          <Text>
            Currently, Equip scales are not provided to patients under{' '}
            {AGE_LIMIT} without prior approval.
          </Text>
          <Text>
            Please ensure that an exception has been granted before proceeding
            with your order.
          </Text>
        </ChakraBox>
      );
    case WarningTypes.EXCEEDS_SCALE_LIMIT:
      return (
        <ChakraBox
          display="flex"
          flexDirection="column"
          gap="12px"
          id={`${TOP_LEVEL_ID}__exceeds-scale-limit`}
        >
          <Text>
            The patient's most recent weight suggests that they may exceed the
            Equip scale's {SCALE_WEIGHT_LIMIT} lb limit.
          </Text>
          <Text>
            Please verify their current weight to confirm if they are eligible
            for the scale.
          </Text>
        </ChakraBox>
      );
    case WarningTypes.NO_RECENT_WEIGHT:
      return (
        <ChakraFlex
          direction="column"
          gap="12px"
          id={`${TOP_LEVEL_ID}__no-recent-weight`}
        >
          <Text variant="body">
            We recommend verifying the patient's weight before proceeding.
          </Text>
          <Text variant="body">
            Equip scales have a maximum capacity of {SCALE_WEIGHT_LIMIT} lbs.
            Please confirm the patient's current weight to ensure eligibility
            for ordering.
          </Text>
        </ChakraFlex>
      );
    default:
      return null;
  }
};

export default WarningContent;
